import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
  useCallback,
} from 'react';
import Tipseen from './Tipseen';

const TipseenContainer = forwardRef(({ children, hover, placement }) => {
  const [showPopover, setShowPopover] = useState(false);
  const [content, trigger] = children;

  const reference = useRef(null);
  const handleShow = useCallback(
    (event) => {
      if (reference.current && !reference.current.contains(event.target))
        setShowPopover(!showPopover);
    },
    [showPopover]
  );

  useEffect(() => {
    if (showPopover) {
      document.addEventListener('mousedown', handleShow);
    } else {
      document.removeEventListener('mousedown', handleShow);
    }
  }, [showPopover, reference, handleShow]);
  return (
    <Tipseen
      hover={hover}
      content={content}
      trigger={trigger}
      fowardRef={reference}
      show={showPopover}
      handleShow={handleShow}
      placement={placement}
    />
  );
});

TipseenContainer.displayName = 'TipseenContainer';

export default TipseenContainer;
